import { orderGroupOperation_Or } from './types.js';
export const cleanOrderGroup = Object.freeze({
    name: 'New Order Group',
    operation: orderGroupOperation_Or,
    items: [],
    subType: 'test',
    tagGroups: []
});
//# sourceMappingURL=consts.js.map